<div
  [ngClass]="{
    'show-details': moreDetails,
    'hide-details': !moreDetails
  }"
>
  <div
    class="noti-container"
    [ngClass]="{
      'noti-last-minute': data?.isLM,
      ' ': !data?.isLM
    }"
  >
    <div
      class="noti-icon-cont1"
      [ngClass]="{
        'noti-green': data?.readOp,
        'noti-neutro': !data?.readOp
      }"
    >
      <ng-container [ngSwitch]="data?.fieldNamePrincipal?.toLowerCase()">
        <svg
          *ngSwitchDefault
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tabler-mail-spark"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path
            d="M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5"
          />
          <path
            d="M11.5 19h-6.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5"
          />
          <path d="M3 7l9 6l9 -6" />
        </svg>

        <i-tabler
          class="icon-noti"
          *ngSwitchCase="'observado'"
          name="alert-circle"
          style="width: 20px; height: 20px"
        ></i-tabler>

        <i-tabler
          class="icon-noti"
          *ngSwitchCase="'corregido'"
          name="pencil"
          style="width: 20px; height: 20px"
        ></i-tabler>

        <i-tabler
          class="icon-noti"
          *ngSwitchCase="'itinerario actualizado'"
          name="pencil"
          style="width: 20px; height: 20px"
        ></i-tabler>
        <i-tabler
          class="icon-noti"
          *ngSwitchCase="'estado actualizado'"
          name="pencil"
          style="width: 20px; height: 20px"
        ></i-tabler>
        <i-tabler
          class="icon-noti"
          *ngSwitchCase="'reconfirmado'"
          name="pencil"
          style="width: 20px; height: 20px"
        ></i-tabler>
        <i-tabler
          class="icon-noti"
          *ngSwitchCase="'servicios y actividades actualizados'"
          name="clipboard-plus"
          style="width: 20px; height: 20px"
        ></i-tabler>
        <i-tabler
          class="icon-noti"
          *ngSwitchCase="'actividad eliminada'"
          name="circle-minus"
          style="width: 20px; height: 20px"
        ></i-tabler>
        <i-tabler
          class="icon-noti"
          *ngSwitchCase="'servicio eliminado'"
          name="circle-minus"
          style="width: 20px; height: 20px"
        ></i-tabler>
      </ng-container>
    </div>
    <div class="noti-details-cont">
      <div class="noti-main-details">
        <div
          class="Noti-title"
          [ngStyle]="{ 'font-weight': data?.readOp ? 'normal' : '430' }"
        >
          <span [ngStyle]="{ color: data?.readOp ? '#303030' : '#E95A1A' }">
            {{ data.usuario ?? "Un usuario" }}
          </span>
          <ng-container [ngSwitch]="data?.fieldNamePrincipal?.toLowerCase()">
            <span *ngSwitchDefault> envió un nuevo pedido.</span>

            <span *ngSwitchCase="'estado actualizado'"
              >realizó un cambio de estado.</span
            >

            <span *ngSwitchCase="'observado'">realizó una observación.</span>

            <span *ngSwitchCase="'corregido'"> realizó una corrección.</span>

            <span *ngSwitchCase="'itinerario actualizado'"
              >realizó nuevos cambios.
            </span>
            <span *ngSwitchCase="'reconfirmado'"
              >realizó una reconfirmación.</span
            >
            <span *ngSwitchCase="'servicios y actividades actualizados'"
              >agregó adiciones.</span
            >
            <span *ngSwitchCase="'last minute'">envió un last minute.</span>
            <span *ngSwitchCase="'servicio eliminado'">eliminó servicio.</span>
            <span *ngSwitchCase="'actividad eliminada'"
              >eliminó actividad.</span
            >
            <br />
          </ng-container>
          File {{ data.fileNumber }}- {{ data.nombreItinerario?.toUpperCase() }}
        </div>
        <div class="fecha-status-cont" style="min-width: 115px">
          <div style="color: #808080">
            <span>Fecha de envío:</span>
            <br />
            {{ data.updatedAt | date: "dd MMM - hh:mm a" }}
          </div>

          <div class="separador"></div>
          <div class="nueva-noti" *ngIf="!data?.readOp"></div>
        </div>
      </div>

      <div class="noti-more-details">
        <div
          class="more-less-details-btn"
          *ngIf="!moreDetails"
          (click)="ChangeMoreDetails()"
        >
          Ver detalles...
        </div>
        <div class="more-detail" *ngIf="moreDetails">
          <div [innerHTML]="data.details"></div>

          <span class="noti-checked-by" *ngIf="data?.readSales">
            <mat-icon class="full-width-icon" style="margin-right: 8px">
              <i-tabler
                class="icon"
                name="user-check"
                style="
                  width: 13.5px;
                  height: 13.5px;
                  font-size: 13.5px;
                  border: 2px;
                  color: #69bd79;
                  marginright: 8px;
                "
              ></i-tabler>
            </mat-icon>
            En SALES recibido por:
            <span id="username" style="margin-left: 4px">
              {{ data.readSales }}</span
            >
          </span>
          <span class="noti-checked-by" *ngIf="data?.readOp">
            <mat-icon class="full-width-icon" style="margin-right: 8px">
              <i-tabler
                class="icon"
                name="user-check"
                style="
                  width: 13.5px;
                  height: 13.5px;
                  font-size: 13.5px;
                  border: 2px;
                  color: #69bd79;
                  marginright: 8px;
                "
              ></i-tabler>
            </mat-icon>
            En OPERACIONES recibido por:
            <span id="username" style="margin-left: 4px">
              {{ data.readOp }}</span
            >
          </span>

          <div class="noti-more-details">
            <div class="more-less-details-btn" (click)="ChangeMoreDetails()">
              Ocultar detalles...
            </div>

            <button
              (click)="handleSendToSales(data.id, 'Op')"
              class="send-btn-base"
              [ngClass]="{
                'send-btn-active': data?.readOp,
                'send-btn-inactive': !data?.readOp
              }"
            >
              <mat-icon class="full-width-icon">
                <i-tabler
                  class="icon"
                  name="check"
                  style="
                    width: 13.5px;
                    height: 13.5px;
                    font-size: 13.5px;
                    border: 2px;
                  "
                ></i-tabler>
              </mat-icon>
            </button>
          </div>
        </div>

        <div class="tag-enviado" *ngIf="data.readOp && !moreDetails">Leído</div>
      </div>
    </div>
  </div>
</div>
